// src/routes/ProtectedRoute.jsx
import { isAuthenticated } from "../utils/auth";
const clientUrl = process.env.REACT_APP_CLIENT_URL || "http://localhost:3000";
const ProtectedRoute = ({ children }) => {
  if (!isAuthenticated()) {
    // 👇 Redirect ra trang client login (frontend public site)
    window.location.href = `${clientUrl}/auth?tab=login`;
    return null;
  }
  return children;
};

export default ProtectedRoute;
